PJQ.inputs = {};

PJQ.inputs.EditorInput = PJQ.views.BaseView.extend({
    baseOptions: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Editor-Input'),
        value: "",
        label: "",
        title: '',
        extraLabelClasses: "",
        extraValueDisplayClasses: "",
        extraEditButtonClasses: "",
        editButtonText: "edit",
        isFormInput: false,
        canEdit: true,
        showSaveButton: true,
        showCancelButton: true,
        onEditStart: _.noop,
        onCancel: _.noop,
        onSave: _.noop
    },
    events: {
        "click .ei-edit-button": "edit",
        "click .ei-cancel-button": "cancel",
        "click .ei-save-button": "save",
        "keyup .ei-input": "onChange",
        "dp.change .ei-input": "onChange"
    },
    inputType: "",
    beforeFirstRender: function () {
        //set value initially in case setValue has custom formatting
        this.setValue(this.getValue());
    },
    beforeRender: function () {
        this.beforeInputRender();
        this.renderData = {
            value: this.getDisplayValue(),
            isEdit: this.isEdit,
            inputType: this.inputType,
            options: this.options
        };
    },
    beforeInputRender: function () {

    },
    afterRender: function () {
        if (this.isEdit) {
            this.$('.ei-input').focus().select();
        }
        this.afterInputRender();
    },
    afterInputRender: function () {

    },
    getDisplayValue: function () {
        return typeof this.options.getDisplayValue === 'function' ? this.options.getDisplayValue(this.options.value) : this.options.value;
    },
    getValue: function () {
        return this.options.value;
    },
    setValue: function (value) {
        this.options.value = value;
    },
    onChange: function (e) {
        if (e && e.which === 13) {
            this.save();
            return;
        }

        this.setValue(this.$('.ei-input').val());
    },
    onEditStart: function () {
        if (typeof this.options.onEditStart === 'function') {
            this.options.onEditStart();
        }
    },
    edit: function () {
        this.onEditStart();
        this.isEdit = true;
        this.render();
    },
    cancel: function () {
        this.options.onCancel(this.getValue());
        this.isEdit = false;
        this.render();
    },
    save: function () {
        this.options.onSave(this.getValue());
        this.isEdit = false;
        this.render();
    }
});

PJQ.inputs.CurrencyEditorInput = PJQ.inputs.EditorInput.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Editor-Input-Currency'),
        digits: 2
    },
    inputType: 'currency',
    afterRender: function () {
        if (this.isEdit) {
            let $input = this.$('.ei-input');
            PJQ.helpers.inputHelpers.inputMaskCurrency($input, this.options.digits);
            if (this.options.value == null) {
                this.options.value = 0;
            }
            $input.val(this.options.digits === 2 ? this.options.value / 100 : this.options.value);
            $input.focus().select();
        }
    },
    onChange: function (e) {
        let inputVal = $(e.currentTarget).val().replace(/ /g, '0'),
            val = parseInt(PJQ.helpers.formatHelpers.numbersOnly(inputVal));
        if (!isNaN(val)) {
            if (this.options.digits === 0) {
                val = val * 100;
            }
        } else {
            val = 0;
        }
        this.setValue(val);
        return val;
    }
});

PJQ.inputs.TextEditorInput = PJQ.inputs.EditorInput.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Editor-Input-Text')
    },
    inputType: 'text'
});

PJQ.inputs.SelectPickerEditorInput = PJQ.inputs.EditorInput.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Editor-Input-Select-Picker'),
        subTemplates: {
            formTemplate: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Editor-Input-Select-Picker-Form'),
        }
    },
    inputType: 'select',
    beforeInputRender: function () {
        if (this.options.isFormInput) {
            this.options.template = this.options.subTemplates.formTemplate;
        }
        this.options.selectPickerOptions = this.options.selectPickerOptions != null ? this.options.selectPickerOptions : {};
    },
    afterInputRender: function () {
        new PJQ.inputs.Selectpicker(_.extend(this.options.selectPickerOptions, {
            el: this.$('select.ei-input'),
            defaultValue: this.options.value,
            onChange: _.bind(function (value) {
                this.options.value = value;
                if (typeof this.options.onChange === 'function') {
                    this.options.onChange(...arguments);
                }
            }, this)
        }));
    },
    onEditStart: function () {
        if (typeof this.options.getChoices === 'function') {
            let fnRender = (choices) => {
                if (PJQ.helpers.objectHelpers.refinedType(choices) === 'array') {
                    this.options.selectPickerOptions.choices = choices;
                    this.render();
                }
            }, choices = this.options.getChoices((ch) => {
                fnRender(ch);
            });
            fnRender(choices);
        }

        return PJQ.inputs.EditorInput.prototype.onEditStart.apply(this, arguments);
    },
    getDisplayValue: function () {
        if (this.options.value != null && _.size(this.options.selectPickerOptions.choices) > 0) {
            let displayVal = _.find(this.options.selectPickerOptions.choices, _.bind(function (choice) {
                return choice.id === this.options.value;
            }, this));
            if (displayVal != null) {
                return displayVal.name;
            }
        } else if (_.size(this.options.defaultDisplayValue) > 0) {
            return this.options.defaultDisplayValue;
        }
        return 'N/A';
    },
});

PJQ.inputs.TextAreaEditorInput = PJQ.inputs.EditorInput.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Editor-Input-Textarea'),
        value: "",
        label: "",
        nullText: "",
        canEdit: true,
        extraLabelClasses: "",
        extraValueDisplayClasses: "",
        extraEditButtonClasses: "",
        onEditStart: _.noop,
        onCancel: _.noop,
        onSave: _.noop
    },
    inputType: 'textarea',
    onChange: function (e) {
        this.setValue($(e.currentTarget).val());
    }
});

PJQ.inputs.DateEditorInput = PJQ.inputs.EditorInput.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Editor-Input-Date'),
        value: "",
        label: "",
        nullText: "",
        canEdit: true,
        extraLabelClasses: "",
        extraValueDisplayClasses: "",
        extraEditButtonClasses: "",
        onEditStart: _.noop,
        onCancel: _.noop,
        onSave: _.noop,
        dateOrientation: "left bottom",
        dateFormat: PJQ.helpers.dateHelpers.dateFormats.DATE_TIME
    },
    inputType: 'date',
    afterRender: function () {
        if (_.size(this.$('.ei-date').find('.ei-input')) > 0) {
            this.datepicker = this.$('.ei-date').find('.ei-input');
            new PJQ.inputs.Datepicker({
                el: this.datepicker,
                datepickerOptions: {
                    format: this.options.dateFormat === PJQ.helpers.dateHelpers.dateFormats.DATE ? PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE : PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE_TIME,
                    defaultDate: this.getValue()
                }
            })
        }
    },
    setValue: function (value) {
        if (PJQ.helpers.objectHelpers.refinedType(value) === 'string')
            this.options.value = new Date(value);
        else
            this.options.value = value;
    },
    onChange: function (e) {
        this.setValue(e.date._d);
    },
    getDisplayValue: function () {
        let value = this.getValue();
        return value == null ? this.options.nullText : PJQ.helpers.dateHelpers.getDateString(value, this.options.dateFormat);
    }
});

PJQ.inputs.AutocompleteInput = PJQ.views.BaseView.extend({
    defaults: {
        data: null,
        dataDisplayProperty: null,
        source: [],
        value: null,
        onSelect: _.noop
    },
    events: {
        'keyup': 'onKeyup'
    },
    afterRender: function () {
        if (!this.$el.hasClass('pt-autocomplete'))
            this.$el.addClass('pt-autocomplete');

        //If there is data passed in, that means we want to be able to return a data object related to the autocomplete item selected
        this.parseSource();

        this.autocomplete = this.$el.autocomplete(_.defaults(this.options, {
            select: _.bind(this.select, this),
            change: _.bind(this.change, this)
        }));

        let self = this;
        this.autocomplete.data('ui-autocomplete')._renderMenu = function (ul, items) {
            _.each(items, _.bind(function (item) {
                this._renderItemData(ul, item);
            }, this));
            $(ul).addClass('pt-autocomplete-menu');
        };
        this.autocomplete.data('ui-autocomplete')._resizeMenu = function () {
            this.menu.element.outerWidth(self.$el.outerWidth());
        };

        if (this.options.value != null) {
            this.setValue(this.getValue());
        }
    },
    parseSource: function () {
        if (PJQ.helpers.objectHelpers.refinedType(this.options.data) === 'array' && this.options.dataDisplayProperty != null) {
            this.options.source = [];
            _.each(this.options.data, _.bind(function (dataItem) {
                this.options.source.push(this.getDataItemValue(dataItem));
            }, this));
        }
    },
    reloadSource: function (obj) {
        if (obj != null) {
            if (obj.data && this.options.dataDisplayProperty) {
                this.options.data = obj.data;
                this.parseSource();
            } else if (PJQ.helpers.objectHelpers.refinedType(obj.source) === 'array') {
                this.options.source = obj.source;
            }
        }
        if (this.autocomplete) {
            this.$el.autocomplete('option', 'source', this.options.source);
        }
    },
    getValue: function () {
        return this.$el.val();
    },
    setValue: function (value) {
        this.$el.val(value);
    },
    refresh: function (e) {
        $(e.currentTarget).autocomplete('search');
    },
    onKeyup: function (e) {
        //Force a refresh after the first character is entered in case there is any page altering markup changes made
        //The autocomplete menu is absolutely positioned, so any dom changes will result in it shifting down/up
        if (_.size(this.$el.val()) === 1) {
            setTimeout(_.bind(function () {
                this.refresh(e);
            }, this), 300);
        }
    },
    change: function (e, ui) {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange($(e.currentTarget).val());
        }
    },
    select: function (e, ui) {
        let $target = $(e.target);
        $target.val(ui.item.value);
        $target.trigger('keyup');
        if (typeof this.options.onSelect === 'function') {
            this.options.onSelect({
                value: ui.item.value,
                match: PJQ.helpers.objectHelpers.refinedType(this.options.data) === 'array' ? (_.find(this.options.data, _.bind(function (dataItem) {
                    return this.getDataItemValue(dataItem).toLowerCase() === ui.item.value.toLowerCase()
                }, this))) : null,
                e
            });
        }
    },
    getDataItemValue: function (dataItem) {
        let result = PJQ.helpers.objectHelpers.refinedType(dataItem, true) === 'backboneModel' ? dataItem.get(this.options.dataDisplayProperty) : dataItem[this.options.dataDisplayProperty];
        return result ? result : '';
    }
});

PJQ.inputs.Datepicker = PJQ.views.BaseView.extend({
    defaults: {
        datepickerOptions: {
            defaultDate: null,
            allowInputToggle: true,
            format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE_TIME,
            icons: {
                time: 'fal fa-clock',
                date: 'fal fa-calendar-alt',
                up: 'fal fa-chevron-up',
                down: 'fal fa-chevron-down',
                previous: 'fal fa-chevron-left',
                next: 'fal fa-chevron-right',
                today: 'fal fa-crosshairs',
                clear: 'fal fa-trash',
                close: 'fal fa-times'
            },
            useCurrent: false,
            minDate: false
        },
        disabledDays: [],
        disableWeekends: false,
        isTimeOnly: false,
        onChange: _.noop,
        onShow: _.noop,
        isShowTimezone: true,
        isEditTimezone: false,
        canEdit: true,
        timezone: new Date().toLocaleTimeString('en-us', {timeZoneName: 'short'}).split(' ')[2]
    },
    events: {
        "dp.show": "onShow",
        "dp.change": "onChange"
    },
    beforeInit: function (options) {
        if (options.datepickerOptions != null) {
            this.options.datepickerOptions = _.defaults(options.datepickerOptions ? options.datepickerOptions : {}, this.defaults.datepickerOptions);

            this.setMinDate(this.options.datepickerOptions.minDate);
            if (this.options.datepickerOptions.defaultDate == null && _.size(this.$el.val()) > 0) {
                this.options.datepickerOptions.defaultDate = this.$el.val();
                this.$el.val('');
            }

            if (typeof this.options.datepickerOptions.defaultDate === 'string' && _.size(this.options.datepickerOptions.defaultDate) > 0) {
                if (!this.options.isDateTime) {
                    this.options.datepickerOptions.defaultDate.replace(/[^0-9\/]/g, '');
                }

                let parsedDate = parsedDate = PJQ.helpers.dateHelpers.parseDateString(this.options.datepickerOptions.defaultDate, this.options.datepickerOptions.format !== PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE);
                if (!isNaN(parsedDate.getTime())) {
                    this.value = parsedDate;
                } else {
                    this.options.datepickerOptions.defaultDate = null;
                    this.value = null;
                }
            } else if (PJQ.helpers.objectHelpers.refinedType(this.options.datepickerOptions.defaultDate) === 'date') {
                this.value = this.options.datepickerOptions.defaultDate;
            } else {
                this.value = null;
            }
            this.options.datepickerOptions.defaultDate = this.value;
        }

        if (this.$el.hasClass('disabled') || this.$el.prop('disabled')) {
            options.canEdit = false;
        }

        if (options.isTimeOnly) {
            options.datepickerOptions.format = 'LT';
        }

        if (_.size(this.options.timezone) === 0) {
            this.options.timezone = new Date().toLocaleTimeString('en-us', {timeZoneName: 'short'}).split(' ')[2]
        }
    },
    afterRender: function () {
        this.$el.prop('disabled', !this.options.canEdit);
        if (this.options.isEditTimezone && this.options.canEdit) {
            this.$el.after('<select class="select-tz wd-75p"></select>');

            let localOffset = new Date().getTimezoneOffset();
            this.timezonePicker = new PJQ.inputs.Selectpicker({
                el: this.$el.parent().find('.select-tz'),
                defaultValue: this.options.timezone,
                isLiveSearch: true,
                choices: this.getTimezoneSelectOptions(),
                isMultiple: false,
                isIntChoices: false,
                onChange: (value) => {
                    this.options.timezone = value;
                    if (typeof this.options.onTimezoneChange === 'function') {
                        this.options.onTimezoneChange(this.options.timezone);
                    }
                }
            });
        } else if ((this.options.isShowTimezone || this.options.isEditTimezone) && (this.isDateTime() || this.options.isTimeOnly)) {
            let timezoneInputAddon = $("<div>", {
                class: 'input-group-append'
            }).append($("<span>", {
                class: 'input-group-text'
            }).text(this.options.timezone));
            this.$el.after(timezoneInputAddon);
        }

        this.datetimepicker = this.$el.datetimepicker(this.getPickerOptions());

        this.$el.on('keyup', _.bind(this.onKeyup, this));
    },
    getPickerOptions: function () {
        return _.defaults({
            daysOfWeekDisabled: this.getDaysOfWeekDisabled()
        }, this.options.datepickerOptions);
    },
    setTimezone: function (tz) {
        if (_.size(tz) === 0 || this.timezonePicker == null) {
            return;
        }

        this.options.timezone = tz;
        this.timezonePicker.setValue(tz);
    },
    getTimezoneSelectOptions: function () {
        return _.map(_.sortBy(PJQ.helpers.dateHelpers.timezones, (timezone) => {
            return timezone.offset;
        }), (timezone) => {
            return {
                id: timezone.abbr,
                title: timezone.abbr,
                name: '(GMT' + PJQ.helpers.dateHelpers.getFormattedTimezoneOffset(timezone.offset) + ') ' + timezone.name
            }
        });
    },
    setDisabledDays: function (value) {
        this.options.disabledDays = value;

        let picker = this.getPicker();
        if (picker != null) {
            picker.options(this.getPickerOptions());
        }
    },
    getDaysOfWeekDisabled: function () {
        let disableDays = [];
        if (this.options.disableWeekends) {
            disableDays.push(...[0, 6]);
        }
        if (_.size(this.options.disabledDays) > 0) {
            disableDays = _.union(disableDays, this.options.disabledDays);
        }
        return _.size(disableDays) > 0 ? disableDays : false;
    },
    isDateTime: function () {
        return this.options.datepickerOptions.format.indexOf('h') !== -1 || this.options.datepickerOptions.format.indexOf('m') !== -1;
    },
    onKeyup: function () {
        let inputVal = this.$el.val(),
            selectedDate = null;
        if (PJQ.helpers.dateHelpers.validateDate(inputVal)) {
            selectedDate = PJQ.helpers.dateHelpers.parseDateString(inputVal);
        }
        this.dateChanged(selectedDate);
    },
    onChange: function (e) {
        if (e.date) {
            this.dateChanged(e.date._d);
        }
    },
    onShow: function () {
        if (typeof this.options.onShow === 'function')
            this.options.onShow(this);
    },
    hide: function () {
        let picker = this.getPicker();
        if (picker != null) {
            picker.hide();
        }
    },
    show: function () {
        let picker = this.getPicker();
        if (picker != null) {
            picker.show();
        }
    },
    dateChanged: function (selectedDate) {
        let isChanged = false,
            isDateTime = this.isDateTime(),
            isTimeOnly = this.options.isTimeOnly;
        if (this.value == null) {
            isChanged = true;
        } else if ((isDateTime || isTimeOnly) && PJQ.helpers.dateHelpers.getDateDiff(selectedDate, new Date(this.value)) !== 0) {
            isChanged = true;
        } else if (!isDateTime) {
            let parsedValue = PJQ.helpers.dateHelpers.getDateString(this.value, PJQ.helpers.dateHelpers.dateFormats.DATE);
            if (typeof parsedValue !== 'undefined' && parsedValue !== PJQ.helpers.dateHelpers.getDateString(selectedDate, PJQ.helpers.dateHelpers.dateFormats.DATE)) {
                isChanged = true;
            }
        }

        if (isChanged) {
            if (!isDateTime && !isTimeOnly && selectedDate != null) {
                selectedDate.setHours(0, 0, 0, 0);
            }
            this.value = selectedDate;

            if (typeof this.options.onChange === 'function') {
                this.options.onChange(typeof selectedDate === 'undefined' ? null : selectedDate);
            }
        }
    },
    disable: function () {
        this.$el.prop('disabled', true);
    },
    setValue: function (newValue) {
        this.value = newValue;
        if (newValue === null) {
            this.$el.val('');
        } else {
            let picker = this.getPicker();
            if (picker != null) {
                picker.setValue(newValue);
            }
        }
    },
    setValueSilently: function (newValue) {
        // This will set the value without triggering the onChange. Useful for initially setting the value.
        this.value = newValue;
        if (newValue === null) {
            this.$el.val('');
        } else {
            this.datetimepicker.off('dp.change');

            let picker = this.getPicker();
            if (picker != null) {
                picker.setValue(newValue);
            }

            this.datetimepicker.on('dp.change', this.onChange.bind(this));
        }
    },
    getValue: function () {
        return this.value;
    },
    setMinDate: function (value) {
        let minDate = value;
        if (minDate) {
            if (typeof minDate === 'string') {
                minDate = new Date(minDate);
            }

            minDate = PJQ.helpers.dateHelpers.getDateString(minDate, PJQ.helpers.dateHelpers.dateFormats.DATE);
        }

        this.options.datepickerOptions.minDate = (minDate ?? false);

        let picker = this.getPicker();
        if (picker != null) {
            picker.minDate(this.options.datepickerOptions.minDate);
        }
    },
    setPickerOption: function (option, value) {
        this.options.datepickerOptions[option] = value;
        let picker = this.getPicker();
        if (picker != null) {
            picker.options(this.options.datepickerOptions);
        }
    },
    getPicker: function () {
        return this.datetimepicker != null ? this.datetimepicker.data('DateTimePicker') : null;
    },
    showError: function (errorText) {
        PJQ.helpers.inputHelpers.setInputError(this.$el, false, {
            errorText: errorText
        });
    },
    hideError: function () {
        PJQ.helpers.inputHelpers.setInputError(this.$el, true);
    }
});

PJQ.inputs.SelectPickerCollection = class {
    constructor($el, models, options = {}) {
        this.options = _.defaults(options, {
            selectPickerOptions: {},
            pickerSelector: null,
            idAttribute: 'cid'
        });

        if (_.size(this.options.pickerSelector) === 0) {
            return;
        }

        this.$el = $el;
        this.models = models;

        this.pickers = {};
        this.initPickers();
    }

    initPickers() {
        this.cleanPickers();
        this.pickers = {};

        let self = this;
        this.$el.find(this.options.pickerSelector).each(function () {
            let model = null,
                id = $(this).closest('tr').attr('id');
            if (_.size(id) > 0) {
                model = _.find(self.models, function (model) {
                    return model[self.options.idAttribute]?.toString() === id;
                }, this);
            }

            if (model != null) {
                let defaultValue = self.options.selectPickerOptions.defaultValue && typeof self.options.selectPickerOptions.defaultValue === 'function' ? self.options.selectPickerOptions.defaultValue(model) : null;
                let opts = _.defaults({
                    el: $(this),
                    defaultValue: defaultValue || (() => {
                        if (_.size(self.options.valueAttribute) > 0) {
                            return PJQ.helpers.objectHelpers.refinedType(model, true) === 'backboneModel'
                                ? model.get(self.options.valueAttribute)
                                : model[self.options.valueAttribute];
                        }
                        return null;
                    }),
                    choices: function () {
                        let choices = self.options.selectPickerOptions.choices;
                        if (typeof choices === 'function') {
                            return choices(model);
                        }
                        return choices;
                    },
                    isDisabled: function () {
                        let disabled = self.options.selectPickerOptions.isDisabled;
                        if (typeof disabled === 'function') {
                            return disabled(model);
                        }
                        return disabled;
                    },
                    onChange: function (value) {
                        if (typeof self.options.onChange === 'function') {
                            self.options.onChange(model, value);
                        }
                    }
                }, self.options.selectPickerOptions);
                self.pickers[model.cid] = new PJQ.inputs.Selectpicker(opts);
            }
        })
    }

    getPickerForId(id) {
        return this.pickers[id];
    }

    cleanPickers() {
        _.each(this.pickers, function (picker) {
            picker.remove();
        });
        this.pickers = {};
    }

    remove() {
        this.cleanPickers();
    }
};

PJQ.inputs.DatePickerCollection = class {
    constructor($el, models, options = {}) {
        this.options = _.defaults(options, {
            datePickerOptions: {},
            pickerSelector: null,
            idAttribute: 'cid'
        });

        if (_.size(this.options.pickerSelector) === 0) {
            return;
        }

        this.$el = $el;
        this.models = models;

        this.pickers = {};
        this.initPickers();
    }

    initPickers() {
        this.cleanPickers();
        this.pickers = {};

        let self = this;
        this.$el.find(this.options.pickerSelector).each(function () {
            let model = null,
                id = $(this).closest('tr').attr('id');
            if (_.size(id) > 0) {
                model = _.find(self.models, function (model) {
                    return model[self.options.idAttribute]?.toString() === id;
                }, this);
            }

            if (model != null) {
                let defaultVal = PJQ.helpers.objectHelpers.refinedType(model, true) === 'backboneModel' ? model.get(self.options.valueAttribute) : model[self.options.valueAttribute],
                    defaultValDate = new Date(defaultVal);
                let opts = _.defaults({
                    el: $(this),
                    onChange: function (value) {
                        if (typeof self.options.onChange === 'function') {
                            self.options.onChange(model, value);
                        }
                    },
                    datepickerOptions: _.defaults({
                        defaultDate: defaultValDate instanceof Date && !isNaN(defaultValDate.getTime()) ? defaultValDate : null
                    }, self.options.datePickerOptions.datepickerOptions)
                }, self.options.datePickerOptions);
                self.pickers[model.cid] = new PJQ.inputs.Datepicker(opts);
            }
        })
    }

    getPickerForId(id) {
        return this.pickers[id];
    }

    cleanPickers() {
        _.each(this.pickers, function (picker) {
            picker.remove();
        });
        this.pickers = {};
    }

    remove() {
        this.cleanPickers();
    }
};

PJQ.inputs.Selectpicker = PJQ.views.BaseView.extend({
    defaults: {
        onChange: _.noop,
        onHide: _.noop,
        onShow: _.noop,
        style: 'btn-default',
        noneSelectedText: 'Select Value',
        selectAllText: 'All Selected',
        defaultValue: null,
        selectOnTab: true,
        isMultiple: false,
        isDisabled: false,
        isGrouped: false,
        allGroupsIsMultiple: false,
        hideDisabled: true,
        isIntChoices: false,
        isLiveSearch: false,
        isBlockSubtext: false,
        mobile: false,
        header: false,
        isMirrorOptionColors: false,
        exclusiveChoices: null,
        mustSelectValue: false,
        mustSelectValuePerOptGroup: false,
        countBeforeTextFormat: 0,
        canEdit: true
    },
    events: {
        "changed.bs.select": "onChange",
        "hidden.bs.select": "onHidden",
        "show.bs.select": "onShow"
    },
    beforeFirstRender: function () {
        if (this.options.isLiveSearch) {
            this.$el.attr('data-live-search', 'true');
        }
        // This will format the text shown in the select picker to be "x items selected" instead of the choices once the choices exceed the number passed to this option.
        if (this.options.countBeforeTextFormat > 0) {
            this.$el.attr('data-selected-text-format', 'count > ' + (this.options.countBeforeTextFormat));
        }
        if (this.options.isBlockSubtext) {
            this.$el.addClass('block-subtext');
        }

        if (this.$el.hasClass('disabled') || this.$el.prop('disabled')) {
            this.options.canEdit = false;
        }

        if (this.$el.length > 0) {
            this.$el.data('selectpickerview', this);
        }

        this.$el.prop('disabled', !this.options.canEdit);
    },
    beforeRender: function () {
        // set the multiple flag on the select element, this is required by the selectpicker library
        // we have to determine if any groups are marked as multiple
        // if isMultiple is passed in and none of the optgroups have the multiple data attribute, that means every optgroup is multiple
        // if even 1 optgroup has the multiple data attribute then we refer to those attributes to determine if each group is multiple
        let isMultipleGroupCount = _.size(this.$('optgroup').filter(function () {
                return $(this).data('multiple') !== undefined
            })),
            hasIsMultipleGroup = isMultipleGroupCount > 0;
        this.options.allGroupsIsMultiple = this.options.isGrouped && this.options.isMultiple && isMultipleGroupCount === 0;

        this.options.isMultiple = this.options.isMultiple || this.$el.hasClass('multiple') || this.$el.prop('multiple') || hasIsMultipleGroup || this.options.allGroupsIsMultiple;
        this.$el.prop('multiple', this.options.isMultiple);


        this.options.isDisabled = this.options.isDisabled || this.$el.hasClass('disabled') || this.$el.prop('disabled');
        this.$el.prop('disabled', this.options.isDisabled);

        if (this.options.choices) {
            this.updateChoices(this.options.choices);
        }

        // if no default value was passed in, try to determine which items are selected by going through the select element
        if (this.options.defaultValue == null) {
            let self = this;
            this.$el.find('option').each(function () {
                if ($(this).attr("selected") && $(this).attr("selected").toLowerCase() === 'selected') {
                    // only set the default value as non null once we have a matched item
                    if (self.options.defaultValue == null) {
                        self.options.defaultValue = self.options.isMultiple ? [] : "";
                    }

                    let val = $(this).attr('value');
                    if (self.options.isMultiple) {
                        self.options.defaultValue.push(val);
                    } else {
                        self.options.defaultValue = val;
                        return false;
                    }
                }
            });
        }

        this.$el.selectpicker(_.defaults({
            choices: typeof this.options.choices === 'function' ? this.options.choices() : this.options.choices
        }, this.options));

        this.$outer = this.$el.closest('.bootstrap-select');
        if ((!this.options.isDisabled || (typeof this.options.isDisabled === 'function' && !this.options.isDisabled()))) {
            this.$outer.find('.dropdown-toggle').removeClass('btn-light');
        }
        //If there are any headers that are empty, hide them
        this.$outer.find('.dropdown-header').each(function () {
            let $header = $(this);
            if (_.size($header.find('.text').html()) === 0) {
                $header.addClass('hidden');
            }
        });

        this.isClicking = false;
        let $clickItems = this.$outer.add(this.$outer.find('button.dropdown-toggle'));
        $clickItems.off('mousedown.isClicking click.isClicking').on('mousedown.isClicking click.isClicking', (e) => {
            this.isClicking = true;
        });

        this.$outer.find('button.dropdown-toggle').off('focus').on('focus', (e) => {
            if (!this.isClicking && this.isCollapsed()) {
                this.toggle();
            }

            this.isClicking = false;
        });

        this.setValue(typeof this.options.defaultValue === 'function' ? this.options.defaultValue() : this.options.defaultValue, false);

        this.afterRender();
        return false;
    },
    checkGroupIsMultiple: function (group) {
        if (this.options.allGroupsIsMultiple) {
            return true;
        }

        if (_.size(group) > 0) {
            let optGroup = this.$('optgroup[data-attr="' + group + '"]');
            if (_.size(optGroup) > 0) {
                return optGroup.data('multiple') === true;
            }
        }
        return false;
    },
    getValue: function () {
        let value = null,
            self = this;
        //If the options call for grouped results, we have to manually get them rather than using built in selectpicker function
        //This is because if there are 2 options in different groups with the same value, we need to check them separately
        if (this.options.isGrouped) {
            value = {};
            this.$('option:selected').each(function () {
                let selectedOptionVal = $(this).val();
                if (selectedOptionVal !== undefined) {
                    if (self.options.isIntChoices) {
                        selectedOptionVal = parseInt(selectedOptionVal);
                        if (isNaN(selectedOptionVal))
                            return;
                    }

                    let selectedGroupAttr = self.getOptionGroupAttribute($(this)),
                        groupIsMultiple = self.checkGroupIsMultiple(selectedGroupAttr);
                    if (value[selectedGroupAttr] == null) {
                        value[selectedGroupAttr] = groupIsMultiple ? [selectedOptionVal] : selectedOptionVal;
                    } else if (groupIsMultiple) {
                        value[selectedGroupAttr].push(selectedOptionVal);
                    }
                }
            });
        } else {
            value = this.$el.selectpicker('val');
            if (this.options.isIntChoices) {
                let valueType = PJQ.helpers.objectHelpers.refinedType(value);
                if (valueType === 'array') {
                    let newValue = [];
                    _.each(value, function (valueItem) {
                        let intValueItem = parseInt(valueItem);
                        if (!isNaN(intValueItem))
                            newValue.push(intValueItem);
                        else
                            newValue.push(valueItem);
                    });
                    value = newValue;
                } else if (valueType === 'string') {
                    let intValue = parseInt(value);
                    if (!isNaN(intValue))
                        value = intValue;
                    else
                        value = null;
                }
            }
        }

        if (value != null && typeof value == 'object' && value.length === 0) {
            return null;
        }

        return value == null && this.options.isMultiple ? [] : value;
    },
    getOptionGroupAttribute: function (option) {
        let groupAttr = option.closest('optgroup').data('attr');
        return _.size(groupAttr) <= 0 ? 'noGroup' : groupAttr;
    },
    setValue: function (value, isKeepExisting, isAllowSelectDisabled) {
        this.lastValue = value;
        if (this.options.isGrouped) {
            if (typeof value === 'object') {
                let valArr = [];
                _.each(value, function (group) {
                    if (typeof group == 'string') {
                        valArr.push(group);
                    } else if (typeof group == 'object') {
                        _.each(group, function (groupValue) {
                            valArr.push(groupValue);
                        });
                    }
                });
                this.$el.selectpicker('val', valArr);
            }
        } else {
            if (this.options.isMultiple) {
                let valArr = [],
                    valueType = PJQ.helpers.objectHelpers.refinedType(value);
                if (valueType === 'string') {
                    valArr.push(value);
                } else if (valueType === 'array') {
                    valArr = value;
                }

                if (isKeepExisting) {
                    valArr = _.union(valArr, this.getValue());
                }

                this.$el.selectpicker('val', valArr);
            } else {
                if (!this.$el.find('option[value="' + (value == null ? '' : value.toString()) + '"]').prop('disabled') || isAllowSelectDisabled) {
                    this.$el.selectpicker('val', value == null ? null : value.toString());
                } else {
                    this.$el.selectpicker('val', null);
                }
            }
        }
        this.$el.selectpicker('render');

        if (this.options.isMirrorOptionColors && !this.options.isMultiple) {
            this.setInputColors();
        }
    },
    selectAll: function () {
        if (this.options.isMultiple)
            this.$el.selectpicker('selectAll');
    },
    deselectAll: function () {
        if (this.options.isMultiple)
            this.$el.selectpicker('deselectAll');
        else
            this.setValue('', false);
    },
    toggle: function () {
        this.$el.selectpicker('toggle');
    },
    isCollapsed: function () {
        return !this.$outer.hasClass('show');
    },
    hide: function () {
        this.$el.selectpicker('hide');
    },
    show: function () {
        this.$el.selectpicker('show');
    },
    enable: function () {
        this.options.isDisabled = false;
        this.$el.prop('disabled', false).removeClass('disabled');
        this.$el.closest('.bootstrap-select').find('.dropdown-toggle').removeClass('btn-light');
        this.refresh();
    },
    disable: function () {
        this.options.isDisabled = true;
        this.$el.prop('disabled', true);
        this.refresh();
    },
    updateChoices: function (choices) {
        this.options.choices = choices;
        this.$el.empty();

        let allIntChoices = true,
            fnMakeOption = (choice) => {
                let style = choice.style ?? '';
                if (this.options.pickerWidth != null) {
                    style += ';overflow:hidden;width: ' + this.options.pickerWidth;
                }

                if (typeof choice === 'string') {
                    allIntChoices = false;
                    return $('<option>', {
                        value: choice,
                        text: choice,
                        style: style
                    });
                } else if (typeof choice === 'object') {
                    allIntChoices = allIntChoices && typeof choice.id === 'number';

                    let opts = {
                        value: choice.id,
                        'data-content': choice.name,
                        style: style,
                        "data-subtext": choice.subtext,
                        disabled: choice.disabled === true
                    }
                    if (_.size(choice.title) > 0) {
                        opts.title = choice.title;
                    }
                    return $('<option>', opts).html(choice.name);
                }
                return '';
            }

        _.each(typeof choices === 'function' ? choices() : choices, function (choice) {
            if (choice == null) {
                this.$el.append($('<option>', {
                    text: this.options.noneSelectedText,
                    disabled: true
                }));
            } else if (choice.choices != null) {
                // this is an optgroup
                let optGroup = $('<optgroup data-attr="' + (choice.id ?? '') + '" label="' + choice.name + '"></optgroup>');
                _.each(choice.choices, function (optChoice) {
                    optGroup.append(fnMakeOption(optChoice));
                }, this);
                this.$el.append(optGroup);
            } else {
                this.$el.append(fnMakeOption(choice));
            }
        }, this);
        this.refresh();

        if (!this.options.isIntChoices && allIntChoices) {
            this.options.isIntChoices = true;
        }
    },
    updateNoneSelectedText: function (newText) {
        this.options.noneSelectedText = newText;
        this.$el.closest('.bootstrap-select').find('.filter-option').html(this.options.noneSelectedText);
    },
    refresh: function () {
        this.$el.selectpicker('refresh');
        this.setValue(this.lastValue);
    },
    onChange: function (event, clickedIndex) {
        if (_.size(this.$el) > 1 && !this.options.isMultiple) {
            let changeEl = $(event.currentTarget);
            this.$el.selectpicker('val', changeEl.selectpicker('val'));
            this.$el.selectpicker('render');
        }

        this.lastValue = this.getValue();

        let optGroup = $(this.$el.find('option')[clickedIndex]).closest('optgroup'),
            choice = $(this.$el.find('option')[clickedIndex]).attr('value');
        if (this.options.isIntChoices) {
            choice = parseInt(choice);
            if (isNaN(choice)) {
                choice = null;
            }
        }

        if (this.options.isMultiple) {
            if (_.size(this.options.exclusiveChoices) > 0) {
                let exclusiveChoices = [];
                if (PJQ.helpers.objectHelpers.refinedType(this.options.exclusiveChoices) === 'array')
                    exclusiveChoices = this.options.exclusiveChoices;
                else
                    exclusiveChoices.push(this.options.exclusiveChoices);

                if (this.options.isGrouped) {
                    if (_.indexOf(exclusiveChoices, choice) !== -1) {
                        _.each(optGroup.find('option'), _.bind(function (option) {
                            let optionValue = parseInt($(option).attr('value'));
                            if (optionValue !== choice) {
                                this.lastValue[optGroup.data('attr')] = _.filter(this.lastValue[optGroup.data('attr')], function (item) {
                                    return item !== optionValue;
                                });
                            }
                        }, this));
                    }
                } else {
                    this.lastValue = (_.indexOf(exclusiveChoices, choice) !== -1) ? [choice] : _.filter(this.lastValue, function (item) {
                        return _.indexOf(exclusiveChoices, item) === -1;
                    });
                }

                this.setValue(this.lastValue);
            }

            // if a value must be selected, one cannot unselect the last selected value.
            if (this.options.mustSelectValue) {
                if (_.size(this.lastValue) === 0) {
                    this.lastValue = [choice];
                    this.setValue(this.lastValue);
                }
            }

            if (this.options.mustSelectValuePerOptGroup && optGroup.data('options') !== 'nullable') {
                let optGroupValueSelected = false;
                if (this.options.isGrouped) {
                    if (_.size(this.lastValue[optGroup.data('attr')]) === 0) {
                        this.lastValue[optGroup.data('attr')] = [choice];
                        this.setValue(this.lastValue);
                    }
                } else {
                    _.each(optGroup.find('option'), _.bind(function (option) {
                        if (this.lastValue.indexOf(parseInt($(option).attr('value'))) !== -1)
                            optGroupValueSelected = true;
                    }, this));

                    if (!optGroupValueSelected) {
                        this.lastValue.push(choice);
                        this.setValue(this.lastValue);
                    }
                }
            }
        }

        if (this.options.isMirrorOptionColors && !this.options.isMultiple) {
            this.setInputColors();
        }

        if (this.options.isGrouped && !this.options.allGroupsIsMultiple) {
            let group = optGroup.data('attr');
            if (_.size(group) > 0) {
                let isGroupMultiple = this.checkGroupIsMultiple(group);
                if (!isGroupMultiple) {
                    this.lastValue[group] = choice;
                    this.setValue(this.lastValue);
                }
            }
        }

        this.options.onChange(this.lastValue);
    },
    onHidden: function () {
        this.options.onHide();
    },
    onShow: function () {
        this.options.onShow();
    },
    setInputColors: function () {
        let selectedOption = this.$('option:selected').first(),
            color = 'inherit';
        if (_.size(selectedOption) > 0) {
            color = selectedOption.css('color');
        }
        this.$('.filter-option').css('color', color);
    },
    showError: function (errorText) {
        PJQ.helpers.inputHelpers.setInputError(this.$el, false, {
            errorText: errorText
        });
    },
    hideError: function () {
        PJQ.helpers.inputHelpers.setInputError(this.$el, true);
    }
});

PJQ.inputs.StatePicker = PJQ.inputs.Selectpicker.extend({
    beforeFirstRender: function () {
        this.options.hideDisabled = false;
    },
    afterRender: function () {
        this.renderStates(this.options.country);
    },
    setValue: function (value, isKeepExisting, isAllowSelectDisabled) {
        PJQ.inputs.Selectpicker.prototype.setValue.call(this, value, isKeepExisting, isAllowSelectDisabled);
    },
    renderStates: function (country) {
        this.$el.find('option').remove();

        let choices = [];
        if (country) {
            if (country.toLowerCase() === 'ca') {
                choices = _.map(PJQ.constants.states.ca, (st) => {
                    return {
                        id: st.abbreviation.toUpperCase(),
                        name: st.name,
                    }
                });
            } else if (country.toLowerCase() === 'us') {
                choices = _.map(PJQ.constants.states.us, (st) => {
                    return {
                        id: st.abbreviation.toUpperCase(),
                        name: st.name,
                    }
                });
            } else {
                let countryDef = _.find(PJQ.constants.internationalCountries, function (c) {
                    return c.name === country;
                });
                if (countryDef) {
                    choices = _.map(countryDef.states, (st) => {
                        return {
                            id: st,
                            name: st,
                            title: st
                        };
                    });
                }
            }
        }

        this.updateChoices(choices);
    }
});

PJQ.inputs.GroupPicker = PJQ.inputs.Selectpicker.extend({
    beforeFirstRender: function () {
        this.options.noneSelectedText = 'Select Group';
        this.options.isIntChoices = true;
        this.options.isLiveSearch = true;
        this.options.size = 20;size: 20
        return PJQ.inputs.Selectpicker.prototype.beforeFirstRender.call(this);
    },
    afterRender: function () {
        if (this.options.project != null) {
            this.options.project.fetchGroups((groups) => {
                let gGroups = _.groupBy(groups.models, (group) => {
                    return group.get('groupDescription');
                });
                this.options.choices = _.map(gGroups, (gGroup, groupDescription) => {
                    return {
                        name: groupDescription,
                        choices: _.map(gGroup, (group) => {
                            return {
                                id: group.id,
                                name: group.get('groupName')
                            }
                        })
                    }
                });
                this.updateChoices(this.options.choices);
            }, true)
            return false;
        } else {
            PJQ.app.session.fetchUserGroups(null, (groups) => {
                let gGroups = _.groupBy(groups.models, (group) => {
                    return group.get('groupDescription');
                });
                this.options.choices = _.map(gGroups, (gGroup, groupDescription) => {
                    return {
                        name: groupDescription,
                        choices: _.map(gGroup, (group) => {
                            return {
                                id: group.id,
                                name: group.get('groupName')
                            }
                        })
                    }
                });
                this.updateChoices(this.options.choices);
            });
        }
    }
});

PJQ.inputs.ProjectLocationPicker = PJQ.inputs.Selectpicker.extend({
    beforeFirstRender: function () {
        this.options.noneSelectedText = 'Select Location';
        this.options.isIntChoices = true;
        this.options.isLiveSearch = true;
        return PJQ.inputs.Selectpicker.prototype.beforeFirstRender.call(this);
    },
    afterRender: function () {
        if (this.options.project != null) {
            this.options.project.fetchLocations((locations) => {
                this.options.choices = locations.getPickerArray();
                this.updateChoices(this.options.choices);
            })
            return false;
        }
    }
});

PJQ.inputs.CountryPicker = PJQ.inputs.Selectpicker.extend({
    beforeFirstRender: function () {
        this.options.hideDisabled = false;
    },
    afterRender: function () {
        let firstOptGroup = {
                name: '',
                choices: []
            },
            secondOptGroup = {
                name: '',
                choices: []
            };
        if (this.options.enableInternational) {
            firstOptGroup.choices.push({
                id: "US",
                name: "United States",
                title: "US"
            });

            firstOptGroup.choices.push({
                id: "CA",
                name: "Canada",
                title: "CA"
            });

            _.each(PJQ.constants.internationalCountries, function (country) {
                secondOptGroup.choices.push({
                    id: country.name,
                    name: country.name,
                    title: country.name
                });
            }, this);
        } else {
            _.each(PJQ.constants.countries, function (country) {
                firstOptGroup.choices.push({
                    id: country.toUpperCase(),
                    name: country.toUpperCase(),
                    title: country.toUpperCase(),
                });
            }, this);
        }

        this.updateChoices(_.size(secondOptGroup) > 0 ? [firstOptGroup, secondOptGroup] : firstOptGroup.choices);

        this.refresh();

        if (this.options.statePicker || this.options.zipInput) {
            this.attachStateZipInputs(this.options.statePicker, this.options.zipInput);
        }
    },
    setValue: function (value, isKeepExisting, isAllowSelectDisabled) {
        PJQ.inputs.Selectpicker.prototype.setValue.call(this, value, isKeepExisting, isAllowSelectDisabled);
        if (this.options.statePicker) {
            this.options.statePicker.renderStates(value);
        }
    },
    attachStateZipInputs: function (statePicker, zipInput) {
        let optionOnChange = this.options.onChange;
        this.options.onChange = function (country) {
            if (statePicker instanceof PJQ.inputs.StatePicker) {
                statePicker.renderStates(country);
            }
            if (zipInput.is('input')) {
                zipInput.val('');
                PJQ.helpers.inputHelpers.inputMaskZip(zipInput, country);
            }
            if (typeof optionOnChange === 'function')
                optionOnChange(country);
        };

        if (zipInput.is('input')) {
            PJQ.helpers.inputHelpers.inputMaskZip(zipInput, this.getValue());
        }
    }
});

PJQ.inputs.HTMLEditor = PJQ.views.BaseView.extend({
    defaults: {
        onChange: _.noop,
        defaultValue: null,
        isDisabled: false,
        isHideTokens: false,
        onInit: _.noop,
        editorHeight: 200
    },
    events: {},
    beforeRender: function () {
    },
    afterRender: function () {
        let tokenButton = _.bind(function (context) {
            let ui = $.summernote.ui;

            // create button
            let button = ui.button({
                contents: 'Tokens',
                tooltip: 'View the available Message Tokens',
                click: _.bind(function () {
                    context.invoke('editor.saveRange');
                    new PJQ.inputs.HTMLEditor.HTMLEditorTokensModal({
                        editor: this.$el.summernote,
                        context: context
                    });
                }, this)
            });

            return button.render();   // return button as jquery object
        }, this);

        let summerNoteOptions = {
            tabsize: 2,
            height: this.options.editorHeight,
            shortcuts: false,
            callbacks: {
                onChange: _.bind(function (contents, $editable) {
                    if (typeof this.options.onChange === 'function') {
                        //this checks if the actual content of the text is blank without spaces
                        try {
                            let $c = $(contents);
                            if (_.size($c) > 0 && _.size($c.text().replace(/\s/gm, "")) === 0) {
                                contents = "";
                            }
                        } catch (err) {
                        }
                        this.options.onChange(contents);
                    }
                }, this)
            },
            toolbar: [
                ['style', ['style']],
                ['font-style', ['bold', 'italic', 'underline', 'clear']],
                ['font', ['fontname']],
                ['font-size', ['fontsize']],
                ['font-color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['hr']],
                ['misc', ['codeview']],
                ['custom', ['token']]
            ],
            oninit: this.options.onInit
        };

        if (!this.options.isHideTokens) {
            summerNoteOptions.buttons = {
                token: tokenButton
            };
        }

        this.$el.summernote(summerNoteOptions);

        if (this.options.defaultValue)
            this.setValue(this.options.defaultValue);
    },
    getValue: function () {
        return this.$el.summernote('code');
    },
    setValue: function (value) {
        this.$el.summernote('code', value);
    },
    pasteValue: function (value) {
        this.$el.summernote('pasteHTML', value);
    },
    enable: function () {
        this.$el.summernote('enable');
    },
    disable: function () {
        this.$el.summernote('disable');
    }
});

PJQ.inputs.HTMLEditor.HTMLEditorTokensModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Project-Tokens'),
        minWidth: '60%',
        context: null
    },
    events: {
        'click .tokens-close': 'onClose',
        'click table.tokens tr td label': 'insertToken'
    },
    insertToken: function (e) {
        //this.options.editor.pasteValue( $(e.currentTarget).text());
        this.removeModal();
        this.options.context.invoke('editor.restoreRange');
        this.options.context.invoke('editor.focus');
        this.options.context.invoke('editor.insertText', $(e.currentTarget).text());
    },
    onClose: function () {
        this.removeModal();
    }
});

PJQ.inputs.ButtonGroup = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Input-Button-Group'),
        colorInactiveButtons: false,
        buttons: [],
        defaultValue: null,
        onChange: _.noop,
        buttonClasses: null,
        fitHeight: false,
        fitWidth: false,
        separateButtons: false,
        canEdit: true
    },
    events: {
        'click .input-btn-group button': 'onChange'
    },
    beforeFirstRender: function () {
        this.value = typeof this.options.defaultValue != 'undefined' ? this.options.defaultValue : null;
    },
    beforeRender: function () {
        this.renderData = {
            options: this.options
        };
    },
    afterRender: function () {
        this.renderButton();
    },
    renderButton: function () {
        let self = this;
        this.$('.input-btn-group button').each(function () {
            if ($(this).data('value') === self.value || ($(this).data('value') === "null" && self.value == null)) {
                if (self.options.colorInactiveButtons) {
                    $(this).removeClass($(this).data('inactiveClass')).addClass($(this).data('activeClass')).addClass('active');
                } else {
                    $(this).removeClass('inactive').addClass('font-weight-normal').addClass('active');
                }
            } else {
                if (self.options.colorInactiveButtons) {
                    $(this).addClass($(this).data('inactiveClass')).removeClass($(this).data('activeClass')).removeClass('active');
                } else {
                    $(this).addClass('inactive').removeClass('font-weight-normal').addClass('active');
                }
            }
        });
    },
    onChange: function (e) {
        this.value = $(e.currentTarget).data('value');
        this.renderButton();
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(this.value);
        }
    },
    getValue: function () {
        return this.value;
    },
    setValue: function (value, triggerChange) {
        this.value = value;
        this.renderButton();
        if (triggerChange && typeof this.options.onChange === 'function') {
            this.options.onChange(this.value);
        }
    }
});

PJQ.inputs.StarRating = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Star-Rating'),
        isReadOnly: false
    },
    events: {
        'click .btn-rate': 'ratingChanged'
    },
    beforeFirstRender: function () {
        this.rating = this.options.rating;
        if (this.rating == null) {
            this.rating = 0;
        }
    },
    renderData: function () {
        return {
            rating: this.rating,
            isReadOnly: this.options.isReadOnly
        };
    },
    ratingChanged: function (e) {
        this.setRating(parseInt(this.$(e.currentTarget).data('stars')));
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(this.rating);
        }
    },
    setRating: function (rating) {
        if (rating == null) {
            this.rating = 0;
        } else {
            this.rating = rating;
        }
        this.render();
    }
});

PJQ.inputs.DayPicker = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'day-picker'),
        isReadOnly: false
    },
    events: {
        'click .btn-work-day': 'dayClicked'
    },
    beforeFirstRender: function () {
        this.days = this.options.defaultValue;
        if (this.days == null) {
            this.days = 0;
        }
    },
    renderData: function () {
        return {
            days: this.days
        };
    },
    reportDayClicked: function (e) {
        this.notificationPerDayRefresh();
    },
    dayClicked: function (e) {
        let dayBtn = $(e.currentTarget);
        if (dayBtn.hasClass('selected')) {
            dayBtn.removeClass('selected');
        } else {
            dayBtn.addClass('selected');
        }

        let val = 0;
        this.$('.btn-work-day.selected').each(function () {
            val += parseInt($(this).data('value'));
        });
        this.days = val;

        this.render();

        if (typeof this.options.onChange === 'function') {
            this.options.onChange(this.days);
        }
    },
    getValue: function(){
        return this.days;
    }
});
